import React from 'react';
import { useSelector } from 'react-redux';

import { selectSiteUrl, selectBrandName } from 'core/selectors/app';
import { selectUserIsIdentified } from 'core/selectors/user';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import { ShowOnMQ } from 'core/modules/MediaQueries/MediaQueries';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import './HeroBanner.scss';

function HeroBanner() {
  const siteUrl = useSelector(selectSiteUrl);
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const brandName = useSelector(selectBrandName);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const { customLoginLink = '' } = window;
  const isCardHolder = userIsIdentified && brandName === 'united_cardholder';
  const loggedOutCTAText = isMobileMQ ? 'Sign in and shop' : 'Claim your bonus today';

  const renderBonusesSection = () => (
    <div className="mn_bonusesSection" data-test="logged-out-bonuses-section">
      <div className="mn_contentWrap">
        <div className="mn_bonus">
          <div className="mn_topBorder" />
          <h3>United MileagePlus<sup>&reg;</sup> members</h3>
          <h2>Earn 500 bonus miles<sup>*</sup></h2>
          <p>When you spend $25 in the next two weeks.</p>
        </div>
        <div className="mn_bonus">
          <div className="mn_topBorder" />
          <h3>United MileagePlus<sup>&reg;</sup> credit card holders</h3>
          <h2>Earn 1,000 bonus miles<sup>**</sup></h2>
          <p>When you spend $25 in the next two weeks.</p>
        </div>
      </div>
    </div>
  );

  const renderloggedOutBannerSection = () => (
    <div className="mn_topSection mn_loggedOutSection" data-test="logged-out-banner-section">
      <div className="mn_contentSection mn_bannerSectionWrap">
        <h3>Welcome to MileagePlus shopping</h3>
        <h2>
          <ShowOnMQ tablet desktop>Getting started is simple: <br /></ShowOnMQ>
          Kickstart your earnings with bonus miles
        </h2>
        <a href={customLoginLink} className="mn_button">{loggedOutCTAText}</a>
      </div>
    </div>
  );

  const renderCardHolderBannerSection = () => (
    <div className="mn_topSection mn_loggedIn mn_cardHolderSection" data-test="card-holder-banner-section">
      <div className="mn_contentSection mn_bannerSectionWrap">
        <h3>Welcome to MileagePlus shopping</h3>
        <h2>
          Start strong: Earn 1,000 bonus miles<sup>*</sup>
        </h2>
        <p>Shop with your United MileagePlus<sup>&reg;</sup> credit card to earn.</p>
        <p>Simply spend $25 in the next two weeks.</p>
        <a href={siteUrl} className="mn_button">Start shopping</a>
      </div>
    </div>
  );

  const renderNonCardHolderBannerSection = () => (
    <div className="mn_topSection mn_loggedIn mn_nonCardHolderSection" data-test="non-card-holder-banner-section">
      <div className="mn_contentSection mn_bannerSectionWrap">
        <h3>Welcome to MileagePlus shopping</h3>
        <h2>
          Start strong: Earn 500 bonus miles<sup>*</sup>
        </h2>
        <p>Simply spend $25 in the next two weeks to earn.</p>
        <p>Want an even bigger bonus? Shop with the United MileagePlus<sup>&reg;</sup> credit card.</p>
        <a href={siteUrl} className="mn_button">Start shopping</a>
      </div>
    </div>
  );

  const renderLoggedInBannerSection = () => (
    isCardHolder ? renderCardHolderBannerSection() : renderNonCardHolderBannerSection()
  );

  return (
    <>
      <div className={`mn_heroBanner ${userIsIdentified ? 'mn_loggedIn' : ''}`}>
        { userIsIdentified ? renderLoggedInBannerSection() : renderloggedOutBannerSection() }
      </div>
      {!userIsIdentified &&
        <div className="mn_bonusSectionWrap">
          {renderBonusesSection()}
        </div>
      }
    </>
  );
}

export default (props) => <ComponentErrorBoundary><HeroBanner {...props} /></ComponentErrorBoundary>;
